import React from 'react';
import { notice } from './docsStyles';

/**
 * DocsNotice
 * Reusable notice component for docs pages
 * Supports different notice types (info, warning)
 */
const DocsNotice = ({ type = 'info', heading, children, className = '' }) => {
  const noticeStyle = {
    ...notice[type],
    marginBottom: '24px'
  };

  const headingStyle = notice.heading;
  const textStyle = notice.text;

  return (
    <div 
      style={noticeStyle} 
      role="alert" 
      aria-live="polite"
      className={className}
    >
      {heading && (
        <div style={headingStyle}>{heading}</div>
      )}
      <div style={textStyle}>
        {children}
      </div>
    </div>
  );
};

export default DocsNotice;




